export default "__VITE_ASSET__HylNKx$B__"